export default __webpack_public_path__ + "static/media/create_challenges_hero.fd867097.png";